import "@/cadence.css";
import { Head } from "vite-react-ssg";
import Navbar from "@/components/landing/Navbar";
import Footer from "@/components/landing/Footer";
import ProgramGenerator from "@/components/landing/ProgramGenerator";

export default function GeneratorPage() {
  return <div className="landing-page generator-page">
    <Head><title>Générateur de programme sportif gratuit — CoachOS</title><meta name="description" content="Essayez le générateur CoachOS : préparez un programme personnalisé selon les objectifs, le niveau et le matériel de votre client, sans créer de compte." /><link rel="canonical" href="https://www.coach-os.eu/generateur-programme" /></Head>
    <Navbar />
    <main id="main-content" className="pt-28">
      <div className="container"><a href="/#features" className="text-sm text-blue-700">← Découvrir CoachOS</a><h1 className="generator-page-title">Votre prochain programme commence ici.</h1></div>
      <ProgramGenerator />
    </main>
    <Footer />
  </div>;
}
